import { useParams, useLocation, Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import CourseCockpitSection from "../components/CourseCockpitSection";
import { MonoButton, PaperBG } from "../kits";



function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const CourseCockpitUser = () => {
  const { courseId } = useParams();
  const { userId } = useAuth();
  const query = useQuery();
  const location = useLocation();
  const courseTitle = location.state?.title;
  

  const registrationId = query.get("registration"); // ✅ holt den Wert aus ?registration=123

  if (!userId || !courseId || !registrationId) 
    return 
  <>

    
     <p>Lade Kurs-Cockpit...jetzt</p>;

</>
  return (
    <>
    <PaperBG>
    <div className="max-w-3xl mx-auto px-6 py-8 font-mono">
      <div>
     
 <div className="py-2">
      <CourseCockpitSection
        userId={parseInt(userId)}
        courseId={parseInt(courseId)}
        registrationId={parseInt(registrationId)}
        courseTitle={courseTitle}
      />
</div>
</div>

<div className="pt-12"> 

     <Link to="/dashboard">
          <MonoButton className="w-full text-xs">Dein + Dashboard hier</MonoButton>
        </Link>

</div>
    </div>
</PaperBG>
</>
  );
};

export default CourseCockpitUser;
